export default [{ text: "供电企业基本情况", url: "/pdf/qiyejieshao/1.pdf" }];
